import { SVGProps } from 'react'

export const FilterAltIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.83714 5.00004H14.1705L9.99548 10.25L5.83714 5.00004ZM3.54548 4.67504C5.22881 6.83337 8.33714 10.8334 8.33714 10.8334V15.8334C8.33714 16.2917 8.71214 16.6667 9.17048 16.6667H10.8371C11.2955 16.6667 11.6705 16.2917 11.6705 15.8334V10.8334C11.6705 10.8334 14.7705 6.83337 16.4538 4.67504C16.8788 4.12504 16.4871 3.33337 15.7955 3.33337H4.20381C3.51214 3.33337 3.12048 4.12504 3.54548 4.67504Z" />
    </svg>
  )
}
